import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import { SessionData } from "../../../model/Session";

export class Endpoint extends ApiEndpoint {
    public delete = (): Promise<AxiosResponse<void>> => {
        return this.connection.delete('/sessions');
    }
}
